import * as React from "react";

const INITIAL = Symbol();

export function useEqualityFn<TState, TResult>(
  selector: (state: TState) => TResult,
  equalityFn: (v1: TResult, v2: TResult) => boolean = Object.is,
): (state: TState) => TResult {
  const latest = React.useRef<TResult | typeof INITIAL>(INITIAL);
  return (state) => {
    const next = selector(state);
    return latest.current !== INITIAL && equalityFn(latest.current, next)
      ? latest.current
      : (latest.current = next);
  };
}
